import { computed, defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'ArticleRatingGroups',
    props: {
        article: {
            required: true,
            type: Object,
        },
        isSport: {
            default: false,
            type: Boolean,
        },
        searchQuery: {
            default: '',
            type: String,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const rootEl = ref();
        const groups = computed(() => {
            const CUSTOM_NAME_REGEX = /\[(.*?)\]/;
            const { fields, field_values: fieldValues, groupfieldid } = props.article.rating;
            let { grouprange } = props.article.rating;
            grouprange = grouprange.replace(/\(\+\)|\(-\)/g, '');
            grouprange = grouprange.replace(/-0/g, '-Infinity');
            const rangesArray = grouprange.split(';');
            return rangesArray.map((range) => {
                const { sub_str: postfix, title: prefix } = fields.find((field) => Number(field.cf_id) === groupfieldid) || {};
                let title = `${prefix} `;
                const customName = range.match(CUSTOM_NAME_REGEX);
                const [rangeFrom, rangeTo] = range.split('-');
                let from = parseInt(rangeFrom, 10);
                let to = parseInt(rangeTo, 10);
                if (customName) {
                    title += ` ${customName[1]}`;
                }
                else if (!isNaN(from) || !isNaN(to)) {
                    from = from || 0;
                    to = to || Infinity;
                    if (to === Infinity) {
                        title += `от ${from}`;
                    }
                    else if (!from) {
                        title += `до ${to}`;
                    }
                    else {
                        title += `${from} — ${to}`;
                    }
                    title += ` ${postfix}`;
                }
                else {
                    title = range;
                }
                // Get group values
                let groupValues = Object.values(fieldValues).reduce((group, groupValue) => {
                    const { float_val: floatVal, string_val: stringVal } = groupValue.values.find((field) => Number(field.cf_id) === groupfieldid) || {};
                    const arrayWithoutRange = rangesArray.filter((value) => value !== range);
                    const fromArray = arrayWithoutRange.map((value) => value.replace(/-.+/g, ''));
                    const toArray = arrayWithoutRange.map((value) => value.replace(/.+-/g, ''));
                    const hasIntersectedValues = fromArray.includes(String(to)) || toArray.includes(String(from));
                    const value = Number(floatVal || stringVal);
                    const isValueMathcesFrom = value && value >= from;
                    let isValueMatchesTo = value <= to;
                    if (hasIntersectedValues) {
                        isValueMatchesTo = value < to;
                    }
                    if (isValueMathcesFrom && isValueMatchesTo) {
                        group.push(groupValue);
                    }
                    return group;
                }, []);
                // Sort group values by position
                groupValues.sort((a, b) => {
                    const { float_val: floatValA = 0 } = a?.values?.find((field) => field.field_title === 'Позиция') || {};
                    const { float_val: floatValB = 0 } = b?.values?.find((field) => field.field_title === 'Позиция') || {};
                    return Number(floatValA) - Number(floatValB);
                });
                // Counting position within a group starting from the first one
                groupValues = groupValues.map((value, i) => {
                    const positionField = value?.values?.find((field) => field.field_title === 'Позиция') || {};
                    positionField.float_val = i + 1;
                    return value;
                }, []);
                return {
                    ...props.article,
                    rating: {
                        ...props.article.rating,
                        field_values: JSON.parse(JSON.stringify(groupValues)),
                        groupTitle: title,
                    },
                };
            });
        });
        function handleBackTop() {
            if (!rootEl.value) {
                return;
            }
            window.scrollTo({
                behavior: 'smooth',
                top: rootEl.value.offsetTop - 56,
            });
        }
        return {
            css,
            groups,
            handleBackTop,
            rootEl,
        };
    },
});
